import { render, staticRenderFns } from "./aboutCompany.vue?vue&type=template&id=3619d9e4"
import script from "./aboutCompany.vue?vue&type=script&lang=js"
export * from "./aboutCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports